import React from "react";
import {
  Card,
  CardBody,
  CardImg,
  CardTitle,
  CardSubtitle,
  CardText,
  CardDeck,
  Col,
} from "reactstrap";
import useAuthStore from "../../stores/useAuthStore";
import { useNavigate } from "react-router-dom";

function SuperDash() {
  const navigate = useNavigate();
  const roles = useAuthStore((state) => state.roles);

  return (
    <div className="animated fadeIn">
      <div className="d-flex">
        <Col sm="12" md="12" lg="12" xl="12">
          <CardDeck className="d-flex gap-3">
            <Card
              onClick={() => navigate("/superuser/schools")}
              style={{ cursor: "pointer" }}
            >
              <CardImg
                top
                width="100%"
                src="img/Elever_img.jpg"
                alt="Card image cap"
              />
              <CardBody>
                <CardTitle className="text-warning">
                  <strong>Skolor</strong>
                </CardTitle>
                <CardSubtitle />
                <CardText>
                  Här administrerar du skolor och dess lärare och elever
                </CardText>
              </CardBody>
            </Card>

            {roles === "Superuser" && (
              <Card
                onClick={() => navigate("/superuser/courses")}
                style={{ cursor: "pointer" }}
              >
                <CardImg
                  top
                  width="100%"
                  src="img/Kurser_img.jpg"
                  alt="Card image cap"
                />
                <CardBody>
                  <CardTitle className="text-danger">
                    <strong>Kurser, moduler &amp; licenser</strong>
                  </CardTitle>
                  <CardSubtitle />
                  <CardText>
                    Här administrerar du kurser, moduler och licenser
                  </CardText>
                </CardBody>
              </Card>
            )}

            <Card
              onClick={() =>
                navigate("/superuser/invoicehistory")
              }
              style={{ cursor: "pointer" }}
            >
              <CardImg
                top
                width="100%"
                src="img/Faktura_img.jpg"
                alt="Card image cap"
              />
              <CardBody>
                <CardTitle className="text-primary">
                  <strong>Orderhistorik</strong>
                </CardTitle>
                <CardSubtitle />
                <CardText />
              </CardBody>
            </Card>

            {roles === "Superuser" && (
              <Card
                onClick={() => navigate("/superuser/users")}
                style={{ cursor: "pointer" }}
              >
                <CardImg
                  top
                  width="100%"
                  src="img/Elever_img.jpg"
                  alt="Card image cap"
                />
                <CardBody>
                  <CardTitle className="text-secondary">
                    <strong>Användare</strong>
                  </CardTitle>
                  <CardSubtitle />
                  <CardText>Administration användare.</CardText>
                </CardBody>
              </Card>
            )}
            <Card
              onClick={() =>
                navigate("/superuser/notifications")
              }
              style={{ cursor: "pointer" }}
            >
              <CardImg
                top
                width="100%"
                src="img/tembg.jpg"
                alt="Card image cap"
              />
              <CardBody>
                <CardTitle style={{ color: "#12445A" }}>
                  <strong>Notiser</strong>
                </CardTitle>
                <CardSubtitle />
                <CardText>Administration notiser.</CardText>
              </CardBody>
            </Card>
            <Card
              onClick={() => navigate("/superuser/licenses")}
              style={{ cursor: "pointer" }}
            >
              <CardImg
                top
                width="100%"
                src="img/templicenses.jpg"
                alt="Card image cap"
              />
              <CardBody>
                <CardTitle style={{ color: "#12445A" }}>
                  <strong>Licenshantering</strong>
                </CardTitle>
                <CardSubtitle />
                <CardText>Administration licenser.</CardText>
              </CardBody>
            </Card>
          </CardDeck>
        </Col>
      </div>
    </div>
  );
}

export default SuperDash;
